export function buildCsvFromResults(
    results: Models.IngestConfigApi.RelevanceTests.RelevanceComparisonResult[],
): Blob {
    const headers = [
        'RunDate', 'ProductKey', 'ProductName', 'Culture', 'KeywordSearchTerm', 'KSampleSize',
        'A_PrecisionAtK', 'A_RecallAtK', 'A_MeanReciprocalRank', 'A_NormalizedDiscountedCumulativeGain',
        'B_PrecisionAtK', 'B_RecallAtK', 'B_MeanReciprocalRank', 'B_NormalizedDiscountedCumulativeGain',
    ];

    const csvRows = results.map((r) => [
        r.runDate,
        r.productKey,
        r.productName,
        r.culture,
        r.keywordSearchTerm,
        r.kSampleSize,
        r.baseline.precisionAtK,
        r.baseline.recallAtK,
        r.baseline.meanReciprocalRank,
        r.baseline.normalizedDiscountedCumulativeGain,
        r.experiment.precisionAtK,
        r.experiment.recallAtK,
        r.experiment.meanReciprocalRank,
        r.experiment.normalizedDiscountedCumulativeGain,
    ].join(','));

    const csvContent = [headers.join(','), ...csvRows].join('\n');

    return new Blob([csvContent], { type: 'text/csv' });
}
